<div class="row d-flex justify-content-center search-container">
    <div class="col-md-6 mb-2 text-right" *ngIf="acl.SYSPAD_PIM_ELEMENT_CREATE === 1">
        <button id="createElement" (click)="openModal()" class="btn btn-lg col-lg-12 btn-primary" data-toggle="modal" data-target="#createModal">{{
            'pim.element.create' | translate }}</button>
    </div>
</div>

<div *ngIf="showDashboards">
    <div class="row">
        <div class="col-lg-6 col-md-12 table-div">
            <app-home-table tableTitle="{{ 'pim.home.last.actions' | translate }}" [data]="lastActions | tableData"
                (action)="onGlobalLastEdit($event, true)" type="lastActions"
                emptyHint="{{ 'pim.home.last.actionsHint' | translate }}"> </app-home-table>
        </div>

        <div class="col-lg-6 col-md-12 table-div">
            <app-home-table tableTitle="{{ 'pim.home.last.updates' | translate }}" [data]="tasks | tableData"
                (action)="onGlobalLastEdit($event, false)" type="lastUpdates"
                emptyHint="{{ 'pim.home.last.updatesHint' | translate }}"> </app-home-table>
        </div>
    </div>
    <div class="row">
        <div class="col table-div">
            <app-home-workflow-table [data]="workflowData" (action)="onWorkflowClick($event)" type="lastWorkflows"
                emptyHint="{{ 'pim.home.workflowHint' | translate }}"></app-home-workflow-table>
        </div>
    </div>
</div>

<div *ngIf="!showDashboards && directElementsAccess && masterKey">
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <span>{{ directElementsAccess[masterKey].name }} :</span>
            <button (click)="showDashboards = !showDashboards" class="btn btn-outline-danger">x</button>
        </div>
        <div class="card-body">
            <div *ngIf="directElementsAccess.elements.length; else elseBlock">
                <div *ngFor="let element of directElementsAccess.elements">
                    <div class="card">
                        <span class="pl-2 pt-3 pb-3"><a [routerLink]="['/pim', 'element', 'update', element.id]" target="_blank">{{
                            element.name }} ({{ element.elementTypeName }}, {{ element.version }})</a> <fa-icon class="text-primary ml-2" (click)="getPreview(element)" [icon]="faEye" style="cursor:pointer;"></fa-icon></span>
                    </div>
                </div>
            </div>
            <ng-template #elseBlock>
                <div class="alert alert-warning" role="alert">
                    {{ 'general.no.result' | translate }}
                </div>
            </ng-template>
        </div>
    </div>
</div>

<swal width="50%" #elementPreviewModal data-backdrop="false" class="modal fade" id="elementPreviewModal" tabindex="-1" role="dialog" aria-labelledby="elementPreviewModalLabel" aria-hidden="true">
    <div *swalPortal>
        <h5 class="modal-title">{{elementPreview.name}}</h5>
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" >
                <div class="modal-body" *ngIf="elementPreview.values.length > 0">
                    <div class="row" *ngFor="let value of elementPreview.values" >
                        <div class="col-4"><b>{{ value.name }}:</b></div>
                        <div class="col-7 value" *ngIf="value.values" >
                            <div *ngFor="let val of value.values">
                                <span *ngIf="value.fieldType == 'date'">{{ _dataService.formatDateValue(val) }}</span>
                                <span *ngIf="value.fieldType != 'date'">{{ val }}</span>
                            </div>
                        </div>
                        <div class="col-8 value" *ngIf="value.collections">
                            <div class="row" *ngFor="let collection of value.collections; let i = index">

                                <div class="col-12">
                                    <div class="row" *ngFor="let input of collection">
                                        <div class="col-3"><b>{{ input.name }} {{i+1}}:</b></div>
                                        <div class="col-8" *ngIf="input.value">
                                            <div class="row" *ngFor="let inputVal of input.value; let col = index">
                                                <span *ngIf="Array.isArray(inputVal)" style="width: 100%;">
                                                    <div class="row pl-0" *ngFor="let inputCollection of inputVal">
                                                        <b class="col-6">{{ inputCollection.name}} {{ col + 1 }} : </b>
                                                        <span class="col-6" *ngIf="inputCollection.fieldType == 'date'">{{ _dataService.formatDateValue(inputCollection.values)}}</span>
                                                        <span class="col-6" *ngIf="inputCollection.fieldType != 'date'">{{ inputCollection.values}}</span>
                                                    </div>
                                                </span>
                                                <span *ngIf="!Array.isArray(inputVal)">
                                                    <span *ngIf="input.fieldType == 'date'">{{ _dataService.formatDateValue(inputVal) }}</span>
                                                    <span *ngIf="input.fieldType != 'date'">{{ inputVal }}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="elementPreview.values.length == 0" role="alert" class="text-center alert alert-warning modal-body">
                    {{ "general.noFieldPreview" | translate }}
                </div>
            </div>
        </div>
    </div>
</swal>

<!-- @TODO: Create a shared component ? -->
<div #createModal data-backdrop="false" class="modal fade" id="createModal" tabindex="-1" role="dialog" aria-labelledby="createModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ "breadcrumb.pim.element.create" | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="chips = []">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="alert alert-info alert-dismissible fade show" role="alert">
                    <i class="pi pi-info-circle"></i> {{ elementsSeparator }}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                                       
                <div class="form-group p-fluid">
                    <p-chips class="form-control" [(ngModel)]="chips" allowDuplicate="false" class="w-100">
                        <ng-template let-item pTemplate="item">
                            <span>{{item}}</span>
                        </ng-template>
                    </p-chips>
                </div>
                               
                <div class="form-group">
                    <select class="form-control" id="modalElements">
                        <option *ngFor="let elementType of elementTypes" value="{{ elementType.id }}">{{ elementType.name }}</option>
                    </select>
                </div>
            </div>
            
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="chips = []">{{ 'general.close' | translate }}</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="create()" [disabled]="!chips.length">{{ 'general.save' | translate }}</button>
            </div>
        </div>
    </div>
</div>